import React from 'react'
import {Layout, Spin, Dropdown, Space, Menu} from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { withRouter} from 'react-router-dom'
import AppMenu from './AppMenu'
import AppBreadcrumb from './AppBreadcrumb'
import FormModal from './FormModal'
import './layout.css'
import {inject, observer} from 'mobx-react'
import i18n from 'i18next'
import {withTranslation} from 'react-i18next'
import en_icon from '../../assets/images/language_icon_en.png'
import zh_icon from '../../assets/images/language_icon_zh.png'
import { Base64 } from 'js-base64'
import auth from '../../utils/auth'

const {Content} = Layout
const storage = window.localStorage

@inject('accountStore', 'uiState','reportManagementStore', 'routerStateModel')
@observer
class AppLayout extends React.Component {
  state = {
    modalVisible: false,
    language: localStorage.getItem('language') || 'zh_CN',
  }

  componentDidMount() {
    const {accountStore} = this.props
    // if (!auth.getToken()) {
    //   this.unmountChatBi()
    //   return
    // }
    // const userPermissionKey = localStorage.getItem('USER_PERMISSION_KEY')
    // const hasChatMenuPermission = Base64.decode(userPermissionKey).includes('intelligentQuery')
    // accountStore.onGetChatBiPermission().then(()=> {
    //   if (!this.isAssistantPage(this.props.location.pathname) && accountStore.chatBiPermission && hasChatMenuPermission) {
    //     this.initchatbi()
    //   }else{
    //     this.unmountChatBi()
    //   }
    // })
  }

  // componentDidUpdate(prevProps) {
//   if (this.isAssistantPage(this.props.location.pathname)) {
//     this.unmountChatBi()
//   } else if (this.isAssistantPage(prevProps.location.pathname)) {
//     this.initchatbi()
//   }
// }

  isAssistantPage = pathname => pathname.includes('/chat') || pathname.includes('/harness')

  unmountChatBi = () => {
    const {chatbiEmbeddedId} = window.g
    const domId = `chatbi-assistant-root-${chatbiEmbeddedId}`
    const chatDom = document.getElementById(domId)
    // 只隐藏不 remove：assistant.js 内部有全局守卫，remove DOM 后重新加载脚本不会重建
    if (chatDom) {
      chatDom.style.display = 'none'
    }
  }

  initchatbi = () => {
    const {chatbiUrl, chatbiEmbeddedId} = window.g
    const domId = `chatbi-assistant-root-${chatbiEmbeddedId}`
    const chatDom = document.getElementById(domId)
    // 已初始化过（被隐藏），直接显示即可，避免重复加载脚本导致不重建
    if (chatDom) {
      chatDom.style.display = ''
      return
    }
    const script = document.createElement('script')
    script.defer = true
    script.async = true
    script.src = `${chatbiUrl}/assistant.js?id=${chatbiEmbeddedId}`;
    script.id = `chatbi-assistant-float-script-${chatbiEmbeddedId}`;
    document.head.appendChild(script);
  }

  toggleLanguage = e => {
    this.setState({language: e})
    i18n.changeLanguage(e).then(() => {
      localStorage.setItem('language', e)
    })
  }
  onLogout = () => {
    const {accountStore, routerStateModel} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    let params = {
      userId: accountInfos?.data?.name || infos?.data?.name
    }
    accountStore.logout(params).then(() => {
      // this.unmountChatBi()
      routerStateModel.clearUrlHistory()
    })
  }
  onChangePassword = () => {
    this.setState({
      modalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      modalVisible: false
    })
  }
  render() {
    const {accountStore, uiState, children, location, t,reportManagementStore} = this.props
    const {language} = this.state
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const {isFetchingExport} = uiState
    return (
      <>
        <Layout>
          <AppMenu renderFlag={reportManagementStore.reportSortChange}/>
          <Content
            style={{
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}>
            <div
              style={{
                height: 60,
                justifyContent: 'space-between',
                paddingRight: 40,
                background: '#ffffff',
                display: 'flex',
                flexFlow: 'rwo nowarp'
              }}>
              <div>
                <AppBreadcrumb pathname={location.pathname}/>
              </div>
              <div style={{display: 'flex', verticalAlign: 'middle'}}>
                <img style={{width: 32, height: 32, marginRight: 20, marginTop: 14, cursor: 'pointer'}}
                    onClick={() => { this.toggleLanguage(language === 'zh_CN' ? 'en_US' : 'zh_CN') }} src={language === 'en_US' ? en_icon : zh_icon}
                    alt="language_icon"/>
                <img alt="avatar" style={{width: 32, height: 32, marginRight: 10, marginTop: 14}} src={require('../../assets/images/icon_avatar.png')}/>
                <Dropdown overlay={(
                  <Menu>
                    <Menu.Item>
                      <a onClick={this.onLogout}>
                        {t(`home.logout`)}
                      </a>
                    </Menu.Item>
                    <Menu.Item>
                      <a onClick={this.onChangePassword}>
                        {t(`home.changePassword`)}
                      </a>
                    </Menu.Item>
                  </Menu>
                )}>
                  <a onClick={e => e.preventDefault()}>
                    <Space>
                      <label style={{height: 60, lineHeight: '60px', fontFamily: 'Arial-BoldMT,Arial', color: '#333', fontSize: 14}}>
                        {accountInfos?.data?.name || infos?.data?.name}
                      </label>
                      <DownOutlined />
                    </Space>
                  </a>
                </Dropdown>
              </div>
            </div>
            <div style={{padding: 15}}>
              <Spin spinning={isFetchingExport}>{children}</Spin>
              <div className='float-page base-float-page'/>
            </div>
          </Content>
        </Layout>
        {this.state.modalVisible ? <FormModal
          modalVisible={this.state.modalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(withRouter(AppLayout))